import { Grid, useMediaQuery } from "@mui/material"
import { FC, useState, useEffect } from "react"
import CustomizedColorInput from "../CreateForm/ColorBase"
import CustomizedInput from "../CreateForm/InputBase"
import { ChooseYourFileButton, EditButton } from "../Custom/Buttons"
import { FontTitleSectionContainer } from "../CustomCss/styled"
import './style.scss'
import FileUploadDialog from "../CreateForm/DialogBase/FileUploadDialog"
import { EmbeddingProps } from "../../pages/Embedding/interface"
const initial = {
  mode: "popover",
  customIcon: "",
  buttonColor: "#000",
  name: "",
  id: ""
}
interface PopoverScreenComponentProps {
  setWidgetConfigDetails: any;
  widgetConfigDetails?: any;
}
type Props = EmbeddingProps & PopoverScreenComponentProps;
const PopoverScreenComponent: FC<Props> = ({ editUUID, setWidgetConfigDetails, widgetConfigDetails }) => {
  const [embedData, setEmbedData] = useState(initial)
  const [editColor, setEditColor] = useState<boolean>(false)
  const [uploadIcon, setUploadIcon] = useState(false)
  const isLessThan1440 = useMediaQuery("(max-width:1439px)");

  useEffect(() => {
    setWidgetConfigDetails((prev: any) => {
      return {
        ...prev,
        customIcon: embedData.customIcon,
        buttonColor: embedData.buttonColor
      }
    })
  }, [embedData])
  useEffect(() => {
    if (widgetConfigDetails?.mode === "popover" && widgetConfigDetails?.customIcon !== undefined && widgetConfigDetails?.buttonColor !== undefined) {
      setEmbedData(widgetConfigDetails)
    }
  }, [widgetConfigDetails.id])
  return (
    <div className="popoverScreen">
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Custom icon
      </FontTitleSectionContainer>
      <Grid item xs={6}>
        <CustomizedInput
          placeholder=""
          value={embedData.customIcon}
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, customIcon: e.target.value }))}
          type="url"
        />
        <ChooseYourFileButton
          onClick={(e: any) => {
            e.preventDefault();
            setUploadIcon(true);
          }}
        />
        <FileUploadDialog
          open={Boolean(uploadIcon)}
          submitHandler={(e?: string) => { setEmbedData((prev) => ({ ...prev, customIcon: e || "" })); setUploadIcon(false) }}
          editUUID={editUUID}
        />
      </Grid>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button color
      </FontTitleSectionContainer>
      <div className="popoverScreenButtonColor">
        <div className="popoverScreenButtonColorName">
          <CustomizedColorInput
            closeHandler={() => setEditColor(false)}
            open={editColor}
            color={embedData.buttonColor}
            setColor={(value: any) => {
              setEmbedData((prev) => ({ ...prev, buttonColor: value }))
            }}
          />
          <span>{embedData.buttonColor}</span>
        </div>
        <EditButton onClick={() => setEditColor(true)}
          variant="contained"
          size="small" />
      </div>
    </div>
  )
}
export default PopoverScreenComponent